import { Box, Icon, Text, View } from "components/ui";
import { Check } from "lucide-react-native";
import React from "react";
import { Typography } from "./Typography";

type Props = {
	stockcode: string;
	sx?: any;
	iconSize?: "sm" | "md" | "lg";
};

const ItemBadge = (props: Props) => {
	let iconSize = props.iconSize || "md";
	let renderedIconSize;
	switch (iconSize) {
		case "sm":
			renderedIconSize = 16;
			break;
		case "md":
			renderedIconSize = 20;
			break;
		case "lg":
			renderedIconSize = 24;
			break;
		default:
			renderedIconSize = 20;
			break;
	}
	const { stockcode } = props;
	let renderedNotificationColor = "";

	return (
		<Box gap={8} flexDirection="row" alignItems="center">
			<Box borderRadius="$full" p={4} alignItems="center" justifyContent="center" width={renderedIconSize} height={renderedIconSize} backgroundColor={"$primarylightblue"}>
				<Icon as={Check} width={renderedIconSize} height={renderedIconSize} color="$basicwhite" />
			</Box>
			<Box>
				<Typography.ParagraphSmall sx={props.sx}>CODE: {stockcode}</Typography.ParagraphSmall>
			</Box>
		</Box>
	);
};

export default ItemBadge;
